import React, { useState } from 'react';
import { MenuItem } from '@mui/material';

import KogModalSideComponent from '@/main/components/modal/ModalSide';
import { getTranslateByKey } from '@/main/services/utils';
import { userIsSupplier } from '@/main/services/utilsUser';
import ModalImages from '@/main/components/shared/modalImages/modalImages';
import { useThreeDotsQuoteContext } from '../contex';

interface IThreeDotsQuoteImageProps {
  guidQuote: string;
  isQuoteCanceled: boolean;
  canDownloadImages: boolean;
}
function ThreeDotsQuoteImage({
  guidQuote,
  isQuoteCanceled,
  canDownloadImages
}: IThreeDotsQuoteImageProps) {
  const {
    closeThreeDotsQuote
  } = useThreeDotsQuoteContext();
  const [openModalImages, setOpenModalImages] = useState<boolean>(false);

  function handleClick() {
    setOpenModalImages(true)
  }
  function closeModalImages() {
    setOpenModalImages(false);
    closeThreeDotsQuote();
  }
  const isSupplier = userIsSupplier();

  return (
    <>
      <MenuItem
        id="id-option-three-dots-images"
        onClick={handleClick}
      >
        {getTranslateByKey('information.images')} / {getTranslateByKey('information.files')}
      </MenuItem>
      <ModalImages
        isOpenModal={openModalImages}
        setIsOpenModal={setOpenModalImages}
        closeModal={closeModalImages}
        canUploadImages={!isQuoteCanceled && !isSupplier}
        canShowPDF={!isSupplier}
        guidQuote={guidQuote}
        guidClaim={""}
        removeDeleteButton
        canDownloadImages={canDownloadImages}
      />
    </>
  )
}

export { ThreeDotsQuoteImage };
